import { SelectMenu, SelectMenuItem, textFontMenuItems } from "@whyuz/components";
import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { TbTypography } from "react-icons/tb";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { buttonStyle, iconSelectStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonFontProps {
  hideOnMobile?: boolean;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonFont = ({ hideOnMobile = true, children }: TextEditorMenuButtonFontProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  const getSelectedFontSelectedOnFocus = () => {
    return editor ? editor.getAttributes("textStyle").fontFamily : null;
  };

  const handleTextFontSelected = (item: SelectMenuItem<unknown>) => {
    if (editor) {
      editor.chain().focus().setFontFamily(item.id).run();
    }
  };

  return (
    <Tooltip content={t("buttons.font")}>
      <div className={`mr-[1px] ${hideOnMobile ? "hidden sm:block" : ""}`}>
        <SelectMenu
          menuItems={textFontMenuItems}
          selectedItemId={getSelectedFontSelectedOnFocus()}
          showSelectedOnButton={false}
          itemNotSelected={children ?? <TbTypography className={iconSelectStyle} />}
          onChange={handleTextFontSelected}
          textPadding="my-1 p-1"
          borderClassName="border-none focus-visible:outline-none focus-visible:ring-gray-800 focus-visible:ring-2"
          textMargin=""
          backgroundClassName={buttonStyle}
          textItemNotSelectedClassName=""
          showSelectedCheck={true}
          showChevron={false}
          disabled={disabled}
        />
      </div>
    </Tooltip>
  );
};
